import { DateRange } from "@mui/x-date-pickers-pro";
import dayjs from "dayjs";
import { Dispatch, SetStateAction } from "react";
import { MRT_TableInstance } from "material-react-table";
import { InternalUser } from "../../../types/app";
import { DashboardNote } from "../../../checks/types";

export interface IAssignable {
  priority?: string;
  name?: string;
  // selectId?: number;
  uniqueIdentifier: string;
  assignedToUser?: InternalUser | null;
  assignedTo?: string;
  orderNumber: string;
  notes: DashboardNote[];
}

export interface Policy {
  id: number;
  // selectId: number;
  uniqueIdentifier: string;
  orderNumber: string;
  type: string;
  revision: number;
  position?: number;
  documentId: number;
  transmittedDocumentId: number;
  status: number | undefined;
  issue?: PolicyIssue;
  assignedToUser: InternalUser | null;
  assignedToName?: string;
  assignedToEmail?: string;
  notes: DashboardNote[];
  policyNumber: string;
  assignedToSendName: string;
  assignedToSendEmail: string;
  assignedToSendUser: InternalUser | null;
  createdBy: string;
  department: string;
  statusCounts: RecordableStatusCounts;
  isRecordablesNotApplicable: boolean;
  note?: string;
  lenderLookupCode: string;
  lenderAdditionalEmail: string;
  checklistTaskStatus: string;
  requestedTaskStatus: string;
  taskNotes: DashboardNote[];
  taskReceivedDate: Date;
  associatedDocuments: AssociatedDoc[];
}

export interface PolicyInfo {
  id: number;
  policyNumber: string;
  amount: number;
  type: string;
  position?: number;
  lenderLookupCode: string;
  lenderAdditionalEmail: string;
  guid?: string;
}
export interface Type {
  id: number;
  label: string;
}
export enum PolicyType {
  Owners = 1,
  Loan = 2
}
export enum PolicyIssue {
  Unresolved = 1,
  Resolved = 2,
  WrittenOff = 3
}

export interface AssignedTo {
  id: number;
  // selectId: number;
  uniqueIdentifier: string;
  orderNumber: string;
  name: string;
  email: string;
}
export interface RecordableStatusCounts {
  sent: number;
  notSent: number;
  recorded: number;
  rejected: number;
}
export interface PoliciesData {
  setDateRange: Dispatch<SetStateAction<DateRange<dayjs.Dayjs>>>;
  loading: boolean;
  policies: Policy[];
  dateRange: DateRange<dayjs.Dayjs>;
  setPolicies: Dispatch<SetStateAction<Policy[]>>;
  assignedToMe: boolean;
  setAssignedToMe: Dispatch<SetStateAction<boolean>>;
  fetchPolicies: (params?: fetchPoliciesParams) => Promise<void>;
  tableRef: React.MutableRefObject<MRT_TableInstance<Policy> | null>;
  setIsDefaultFilter: Dispatch<SetStateAction<boolean>>;
  isDefaultFilter: boolean;
  unsentOnly: boolean;
  setUnsentOnly: Dispatch<SetStateAction<boolean>>;
}

interface fetchPoliciesParams {
  useLoader?: boolean | undefined;
  resetPagination?: boolean | undefined;
}

export interface User {
  id: number;
  name: string;
  email: string;
  username: string;
}

export interface assignedToResponse {
  policyId: number;
  notes: DashboardNote[];
  assignedTo: AssignedTo;
}
export interface ConcatenatedDocumentTypes {
  fullPath: string;
  subcategoryId: string;
  description: string;
}

export interface Document {
  mTANumber: string | undefined;
  username?: string;
  description: string;
  subcategoryId: string;
  base64File: string;
  fileName: string;
  applicationInitiator: string;
}
export interface AssociatedDoc {
  policyId: number;
  documentId: number;
  policy: Policy;
}
